import React, { useEffect } from 'react';
import Landing from './landing';
import Team from './team';
import Planets from './planets';
import Functions from './functions';
import Patrocinadores from './patrocinadores';
import particlesConfig from '../components/particlesConfig';
import Style from '../assets/css/particles.module.css';
import RecentEvents from './events';

const ParticlesComponent = () => {
    useEffect(() => {
        const loadParticles = () => {
            if (window.particlesJS) {
                window.particlesJS('background', particlesConfig);
            }
        };

        const scriptId = 'particles-js-script';
        let script = document.getElementById(scriptId);

        if (!script) {
            script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js';
            script.async = true;
            document.body.appendChild(script);
            script.onload = loadParticles;
        } else {
            loadParticles();
        }

        return () => {
            // Opcional: Limpiar el contenedor si es necesario
            const background = document.getElementById('background');
            if (background) background.innerHTML = '';
        };
    }, []);

    return (
        <>  
            <div id="background" className={Style.background} />
            <Landing />
            <Team />
            <Functions />
            <Planets />
                {/* <Patrocinadores /> */}
            <RecentEvents />
        </>
    );
};

export default ParticlesComponent;
